import angular from 'angular';
import _ from 'lodash';

angular.module('stockNew', ['application']);

angular.module('stockNew').config(["$stateProvider", "$translatePartialLoaderProvider", function($stateProvider: any, $translatePartialLoaderProvider: any) {
    $translatePartialLoaderProvider.addPart('stock');

    $stateProvider.state('app.new.stock', {
        url: '/stock',
        redirectTo: 'app.new.stock.management',
    });

    $stateProvider.state('app.new.stock.management', {
        url: '/management',
        component: 'stockManagement'
    });

    $stateProvider.state('app.new.stock.movements', {
        url: '/movements',
        component: 'stockMovements',
        // template: `<stock-movements />`
    });

    $stateProvider.state('app.new.stock.new-movement', {
        url: '/new-movement',
        template: `<stock-new-movement
                    [mode]="$resolve.mode"
                    [movements]="$resolve.movements"
                    [stock-location-id]="$resolve.stockLocationId">
                </stock-new-movement>`,
        params: {
            mode: null,
            movements: null,
            stock_location_id: null
        },
        resolve: {
            mode: ["$stateParams", ($stateParams: any) => $stateParams.mode],
            movements: ["$stateParams", ($stateParams: any) => $stateParams.movements],
            stockLocationId: ["$stateParams", ($stateParams: any) => $stateParams.stock_location_id]
        }
    });
}]);